import React, {PureComponent} from "react"
import {Col} from "react-bootstrap"

import {FormattedMessage, FormattedDate} from "@irati/utils/lang"

import {RewardAvatar, StyledRow, StyledHr, StyledButton, Title, SubTitle} from "./styled/StyledItem"

interface Props {
  createdAt: string,
  title: string,
  imageSrc: string,
  handleClick(event: any): void,
  subTitle?: string
}

export default class ItemTemplate extends PureComponent<Props> {
  render() {
    const {createdAt, title, subTitle, imageSrc, handleClick} = this.props
    return (
      <StyledRow>
        <StyledHr />
        <Col xs={3} sm={2}>
          <RewardAvatar src={imageSrc} extraLarge withShadow />
        </Col>
        <Col xs={4} sm={5}>
          <Title>{title}</Title>
          {subTitle && <SubTitle>{subTitle}</SubTitle>}
        </Col>
        <Col xsHidden sm={3}>
          <FormattedDate year="numeric" month="short" day="2-digit" value={createdAt} />
        </Col>
        <Col xs={5} sm={2}>
          <StyledButton onClick={handleClick} small>
            <FormattedMessage id="recognition.account.rewards.viewButton" />
          </StyledButton>
        </Col>
      </StyledRow>
    )
  }
}
